import { render, staticRenderFns } from "./ShortcutLink.vue?vue&type=template&id=48699fd8&scoped=true"
import script from "./ShortcutLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutLink.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ShortcutLink.vue?vue&type=style&index=0&id=48699fd8&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48699fd8",
  null
  
)

export default component.exports